import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useRealtimeStore } from '../../../shared/realtime/realtimeStore'
import type { ManagerPeriodKey } from './types'

const PERIODS: { key: ManagerPeriodKey; label: string }[] = [
  { key: 'day', label: 'День' },
  { key: 'week', label: 'Неделя' },
  { key: 'month', label: 'Месяц' },
  { key: 'quarter', label: 'Квартал' },
]

function formatAgo(s: number): string {
  if (s < 60) return `${s} сек назад`
  if (s < 3600) return `${Math.floor(s / 60)} мин назад`
  return `${Math.floor(s / 3600)} ч назад`
}

export interface ManagerHeaderProps {
  managerName: string
  clientsCount: number
  period: ManagerPeriodKey
  onPeriodChange: (key: ManagerPeriodKey) => void
  fetchedAt: number | null
}

export function ManagerHeader({
  managerName,
  clientsCount,
  period,
  onPeriodChange,
  fetchedAt,
}: ManagerHeaderProps) {
  const wsStatus = useRealtimeStore((s) => s.status)
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [])

  const live = wsStatus === 'connected'
  const ago = fetchedAt ? Math.max(0, Math.floor((now - fetchedAt) / 1000)) : null

  return (
    <div className="flex items-start justify-between flex-wrap gap-3">
      <div>
        <h1 className="text-xl font-semibold text-gray-900">Моя работа · Менеджер</h1>
        <div className="text-xs text-gray-500 flex items-center gap-2 mt-0.5 flex-wrap">
          <span className="text-gray-700 font-medium">{managerName}</span>
          <span>·</span>
          <span>{clientsCount} клиентов</span>
          {ago !== null && (
            <>
              <span>·</span>
              <span>Обновлено {formatAgo(ago)}</span>
            </>
          )}
          <span>·</span>
          <span
            className={`inline-flex items-center gap-1 ${
              live ? 'text-emerald-600' : 'text-gray-400'
            }`}
          >
            <span
              className={`w-1.5 h-1.5 rounded-full ${live ? 'bg-emerald-500' : 'bg-gray-300'}`}
            />
            {live ? 'Live' : 'Offline'}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <div className="inline-flex rounded-xl border border-gray-200 bg-white overflow-hidden">
          {PERIODS.map((p) => (
            <button
              key={p.key}
              onClick={() => onPeriodChange(p.key)}
              className={`px-3 py-1.5 text-sm transition-colors ${
                period === p.key ? 'bg-gray-900 text-white' : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              {p.label}
            </button>
          ))}
        </div>
        <Link
          to="/requests/new"
          className="px-3 py-1.5 rounded-xl bg-brand-600 text-white text-sm hover:bg-brand-700 transition-colors"
        >
          + Новая заявка
        </Link>
      </div>
    </div>
  )
}
